import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

function getDeviceType(): string {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(ua)) return "mobile";
  return "desktop";
}

function getBrowser(): string {
  const ua = navigator.userAgent;
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("SamsungBrowser")) return "Samsung";
  if (ua.includes("Opera") || ua.includes("OPR")) return "Opera";
  if (ua.includes("Edg")) return "Edge";
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Safari")) return "Safari";
  return "Outro";
}

function getOS(): string {
  const ua = navigator.userAgent;
  if (ua.includes("Win")) return "Windows";
  if (ua.includes("Mac")) return "macOS";
  if (ua.includes("Linux")) return "Linux";
  if (/android/i.test(ua)) return "Android";
  if (/iphone|ipad|ipod/i.test(ua)) return "iOS";
  return "Outro";
}

function getDomain(url: string): string | null {
  try {
    const u = new URL(url);
    return u.hostname.replace("www.", "");
  } catch {
    return null;
  }
}

function getSessionId(): string {
  let sid = sessionStorage.getItem("_vm_sid");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("_vm_sid", sid);
  }
  return sid;
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const referrer = document.referrer || null;
    const referrerDomain = referrer ? getDomain(referrer) : null;

    // Don't track if referrer is same domain (internal navigation already tracked by path)
    const isSameOrigin = referrerDomain && window.location.hostname.replace("www.", "") === referrerDomain;

    const slugMatch = location.pathname.match(/^\/menu\/([^/]+)/);

    const visit = {
      page_path: location.pathname,
      referrer: isSameOrigin ? null : referrer,
      referrer_domain: isSameOrigin ? null : referrerDomain,
      utm_source: params.get("utm_source") || null,
      utm_medium: params.get("utm_medium") || null,
      utm_campaign: params.get("utm_campaign") || null,
      utm_term: params.get("utm_term") || null,
      utm_content: params.get("utm_content") || null,
      device_type: getDeviceType(),
      browser: getBrowser(),
      os: getOS(),
      session_id: getSessionId(),
      restaurant_slug: slugMatch?.[1] || null,
    };

    supabase.from("page_visits").insert(visit as any).then(() => {});
  }, [location.pathname]);
}
